export default "__VITE_PUBLIC_ASSET__ab364b73__"